import "#vendor/humps.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Serializers ??= {};

AssessmentBuilder.Serializers.FormInput = class FormInput {
  static serialize(object, prefix = null) {
    const inputs = jQuery("<div>");
    _.each(object, (value, key) => {
      if (value && typeof value === "object") {
        value = JSON.stringify(value);
      }
      key = humps.decamelize(key);
      if (prefix) {
        key = `${prefix}[${key}]`;
      }
      return inputs.append(jQuery("<input>", { type: "hidden", name: key, value }));
    });

    return inputs.html();
  }
};
